import React, { Fragment } from "react";

const DataPrivacy = (props) => {
  return (
    <div className="mt-5">
      <div className="font-bold text-orange-500 text-lg border-b p-2 mb-2">
        Data Privacy
      </div>
      <p className="justify text-sm indent-10 mb-5 border-b p-2">
        I hereby authorize the City Government of Parañaque to collect and
        process the data indicated in this form, I understand that my personal
        information is protected by R.A. No. 10173 - "
        <em className="font-bold text-gray-500">Data Privacy Act of 2012</em>"
        and that I am required to provide truthful information in processing my
        application with regard to payment of Local Government taxes, dues, and
        fees.
      </p>
      {props.withAgree && (
        <div className="text-center">
          <label className="">
            <input
              type="checkbox"
              className="mr-2"
              style={{
                height: "18px",
                width: "18px",
                borderRadius: "10px",
              }}
              name="agree"
              checked={props.agree}
              onClick={(e) => props.onChange(e.target.checked)}
            />
            <span className="text-sm">I Agree</span>
          </label>
        </div>
      )}
    </div>
  );
};

export default DataPrivacy;
